// React
import React from 'react'
// External libs
import classNames from 'classnames'
// Material UI
import { IconButton } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
// Styles
import useStyles from './CustomCheckCircleButton.styles'
import CustomTooltip from '../../custom-tooltip'

const CustomCheckCircleButton = ({
  classes,
  color,
  disabled,
  onClick,
  isArrowShown = false,
  titleCheckToolTip = '',
  openToolTip = false,
  onOpenToolTip = e => {},
  onCloseToolTip = e => {},
}) => {
  const componentClasses = useStyles({ disabled })

  return (
    <CustomTooltip
      classes={{ popper: componentClasses.tooltip }}
      isArrowShown={isArrowShown}
      title={titleCheckToolTip}
      open={openToolTip}
      placement='top'
      onOpen={onOpenToolTip}
      onClose={onCloseToolTip}
    >
      <IconButton
        aria-label='CheckCircle'
        className={classNames(componentClasses.button, classes.button)}
        color={color}
        disabled={disabled}
        onClick={onClick}
      >
        <CheckCircle
          className={classNames(componentClasses.icon, classes.icon)}
        />
      </IconButton>
    </CustomTooltip>
  )
}

CustomCheckCircleButton.defaultProps = {
  classes: {},
}

export default CustomCheckCircleButton
